import AdminApi from '../../../services/api'
import swal from 'sweetalert2';
import session from "../../../services/session";
import CONFIG_COMPANY from "../../../services/myConfig";
import Loc from "../../../services/localization";

const AdminApiService = new AdminApi()
const LocService = new Loc()

export default {
    data() {
        return {
            locale: LocService,
            id: 0,
            name: '',
            role: '',
            restOfTrainings: 0,
            paidMoney: 0,
            trainingNumber: 0,
            trainingType: '',
            expireDate: null,
            user: null,
            hasActivePayment: true,
            payments: [],
            dates6 : [],
            dates12 : [],
            has6MonthLoyality: 0,
            has12MonthLoyality: 0,
            canExtendPayment: false,
            showLoyalty: false,
            showRestTrainings: true,
            additionalServiceTypes: [],
            additionalServiceTypesTitle: '',
            additionalServiceTypesCount: 0,
        }
    },
    computed : {
        orderedPayments : function () {
            function compare(a,b) {
                if (a.paidDate < b.paidDate)
                    return 1;
                if (a.paidDate > b.paidDate)
                    return -1;
                return 0;
            }
            return this.payments.sort(compare)
        }
    },
    methods: {
        formatDate: formatDate,
        formatDate2: formatDate2,
        addPayment: addPayment,
        loyality6Style: loyality6Style,
        extendPayment: extendPayment,
        loyality12Style: loyality12Style,
        getMe: getMe,
        getTrainingCountClass: getTrainingCountClass,
        getAdditionalServicesClass: getAdditionalServicesClass,
        load: load,
        generateDates: generateDates,
        getPaymentClassTd: getPaymentClassTd,
        editPayment: editPayment,
        isMobile() {
            return window.innerWidth <= 850; // Adjust the breakpoint as needed
        },
         compare(a,b) {
            if (a.paidDate < b.paidDate)
                return 1;
            if (a.paidDate > b.paidDate)
                return -1;
            return 0;
        }
    },

    beforeMount() {
        this.role = session.getRole();
        this.id = this.$route.query.id;
        this.name = this.$route.query.name;
        if(this.$route.query.restOfTrainings != null){
            this.restOfTrainings = this.$route.query.restOfTrainings;
        }
        if(this.$route.query.expireDate != null){
            this.expireDate = this.$route.query.expireDate;
        }
        this.canExtendPayment = session.getConfig().canExtendPayment;
        this.showRestTrainings = session.getConfig().showRestTrainings == null ? true : session.getConfig().showRestTrainings
        if(session.getConfig().additionalServiceTypes != null && session.getConfig().additionalServiceTypes.length > 0){
            this.additionalServiceTypes = session.getConfig().additionalServiceTypes.split(";").filter(e => e.length > 0)
        }
        this.generateDates();
        this.load()
        this.getMe()
    }
}

function generateDates(){
    let date = new Date(Date.now())
    date.setDate(15)
    this.dates6 = []
    this.dates12 = []
    var i = 0;
    for(i = 0; i < 12; i++){
        var newDate =  date.getTime() - 1000 * 60 * 60 * 24 * 31 * (i + 1);
        var tempDate = new Date(newDate)
        tempDate.setDate(15)
        if(i < 6){
            this.dates6.push(this.formatDate2(tempDate.getTime()))
        }
        this.dates12.push(this.formatDate2(tempDate.getTime()))
    }
}

function formatDate2(date) {
    return this.$moment(new Date(date)).format('DD-MM-YYYY')
}

function load() {
    let _self = this;
    let date = new Date(Date.now())
    date.setDate(15)
    AdminApiService.getMyPayment()
        .then((response) => {
            _self.payments = response.data.sort((a,b) => _self.compare(a,b));
            var paymentsForCheckActive = _self.payments.filter(p => p.additionalService == null || p.additionalService === false);
            if(paymentsForCheckActive.length > 0){
                _self.paidMoney = paymentsForCheckActive[0].paidMoney
                _self.trainingNumber = paymentsForCheckActive[0].trainingNumber
                _self.trainingType = paymentsForCheckActive[0].trainingTypes
                _self.expireDate = paymentsForCheckActive[0].expireDate
                var currentDate = new Date();
                currentDate.setHours(0, 0, 0, 0);
                const currentTimeInMilliseconds = currentDate.getTime();
                if(currentTimeInMilliseconds > (paymentsForCheckActive[0].expireDate * 1000 + 10800000)){
                    _self.hasActivePayment = false;
                }else{
                    _self.hasActivePayment = true;
                }
            }else{
                _self.hasActivePayment = false;
            }

            if (paymentsForCheckActive.length > 0) {
                _self.name = _self.payments[0].name + ' ' + _self.payments[0].surname;
            }
        })
        .catch(error => {
            console.log(error);
            swal(LocService.t('label_error'), error.data.localized_error_message, 'error')
        })
}

function formatDate(date) {
    return this.$moment(new Date(date * 1000)).format('DD-MM-YYYY')
}

function addPayment() {
    this.$router.push('/add-payment?id=' + this.id)
}


function getPaymentClassTd(payment) {
    if(payment.paidMoney <= 0){
        return "background: red;"
    }
}

function editPayment(paymentId) {
    this.$router.push('/edit-payment?id=' + paymentId)
}

function loyality6Style(){
    return this.has6MonthLoyality >= 6 ? 'color: green;' : 'color: red;'
}

function loyality12Style(){
    return this.has12MonthLoyality >= 12 ? 'color: green;' : 'color: red;'
}


function getTrainingCountClass(){
    if(this.restOfTraining === 0 || this.isDebtor) return 'training-count red'
    if(this.restOfTraining <= 3 || this.paymentStyle === 'orange') return 'training-count orange'
    return 'training-count green';
}

function getAdditionalServicesClass(){
    if(this.additionalServiceTypesCount < 0 ) return 'training-count red'
    return 'training-count green';
}

function extendPayment(){
    let _self = this;
    AdminApiService.extendPayment()
        .then((response) => {
            swal(LocService.t('label_success'), LocService.t('label_success_extend_payment'), 'success')
            _self.load();
        })
        .catch(error => {
            swal(LocService.t('label_error'), error.data.localized_error_message, 'error')
        })
}

function getMe() {
    let _self = this;
    if(localStorage.getItem('ACCESS_TOKEN') == null) return;
    AdminApiService.getProfile()
        .then((response) => {
            _self.user = response.data;
            _self.additionalServiceTypesTitle = _self.user.additionalServiceType;
            _self.additionalServiceTypesCount = _self.user.additionalServiceCount != null ? _self.user.additionalServiceCount: 0;
        })
        .catch(error => {
            // swal(LocService.t("label_error"), error.data.localized_error_message, 'error')
        })
}


// WEBPACK FOOTER //
// ./src/components/Users/Profile/MyPayments.js